const {FilterDataConfiguration} = require("./configuration/filter-data-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");

const FilterDataStepPanelTabs = {
    configuration: FilterDataConfiguration,
    preview: PreviewTab,
};
exports.FilterDataStepPanelTabs = FilterDataStepPanelTabs;
